import BaseValidator from 'services/validations/base-validator';
import Const from 'const';

class SecondaryDoubleStackCombinationsValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {stacking} = this.dependencies;
        const items = stacking.getItems();

        items.forEach((item) => {
            if (!item.isSecondaryStackTypeDouble()) {
                return;
            }

            const combinations = item.getSecondaryStackCombinations();

            let isKeyCombinationChosen = false;
            let checkedQuantity = 0;
            for (let key in combinations) {
                if (combinations[key]) {
                    checkedQuantity++;
                }

                const isKeyCombination = Const.SECONDARY_STACK_COMBINATION_TYPE_4 === Number(key);

                if (isKeyCombination && combinations[key]) {
                    isKeyCombinationChosen = true;
                }
            }

            if (isKeyCombinationChosen && 1 >= checkedQuantity) {
                this.addError('"RB + DEF same team" cannot be the only option for 2 Secondary Stacks.');
            }
        });
    }
}

export default SecondaryDoubleStackCombinationsValidator;
